import {
  confirmRefundOffer,
  deleteRefundOffer,
  getManageFlowBookingById,
  getManageFlowBookingByNumberAndEmail,
  getManageFlowTravelAccountsMap,
  initiateExtrasRefund,
  initiateLegsRefund,
  initiateNonTripOffersRefund,
  sendTicketsToEmail,
} from '@/features/manage/manageActions';
import {
  applyProfileCard,
  deleteProfile,
  getProfileActiveTickets,
  getProfileActiveTravelPasses,
  getProfileActiveVouchers,
  getProfileConsents,
  getProfileHistoryTickets,
  getProfileHistoryTravelPasses,
  getProfileHistoryVouchers,
  saveProfileConsents,
  updateProfile,
} from '@/features/profile/profileActions';
import {
  abandonExchange,
  addPurchaseFlowBookingAncillaries,
  createPurchaseFlowNonTripOfferBooking,
  createPurchaseFlowTripOfferBooking,
  deletePurchaseFlowBooking,
  getAllUpgradeExchangeOffers,
  getInboundExchangeOffers,
  getInboundJourneys,
  getInboundUpgradeExchangeOffers,
  getNonTripOffers,
  getOutboundExchangeOffers,
  getOutboundJourneys,
  getOutboundUpgradeExchangeOffers,
  getPurchaseFlowBookingAdditionalOffersSearch,
  getPurchaseFlowBookingById,
  getPurchaseFlowTravelAccountsMap,
  initiateAdyenPayment,
  initiateExternalPayment,
  initiateKlixPayment,
  initiateZeroPayment,
  startExchange,
  updateBookingPassengers,
  updatePurchaseFlowBookingPurchaser,
} from '@/features/purchase/purchaseActions';
import {
  changePassword,
  resetPassword,
  sendPasswordResetLink,
} from '@/features/reset-password/resetPasswordActions';
import { createLoadingSelector } from '@/store/utils';

export const purchaseFlowBookingFetchingLoadingSelector = createLoadingSelector(
  getPurchaseFlowBookingById
);

export const outboundOrInboundJourneysLoadingSelector = createLoadingSelector(
  getOutboundJourneys,
  getInboundJourneys,
  getOutboundExchangeOffers,
  getInboundExchangeOffers,
  getOutboundUpgradeExchangeOffers,
  getInboundUpgradeExchangeOffers,
  getAllUpgradeExchangeOffers
);

export const outboundJourneysLoadingSelector = createLoadingSelector(
  getOutboundJourneys,
  getOutboundExchangeOffers,
  getOutboundUpgradeExchangeOffers,
  getAllUpgradeExchangeOffers
);

export const inboundJourneysLoadingSelector = createLoadingSelector(
  getInboundJourneys,
  getInboundExchangeOffers,
  getInboundUpgradeExchangeOffers,
  getAllUpgradeExchangeOffers
);

export const nonTripOffersLoadingSelector =
  createLoadingSelector(getNonTripOffers);

export const purchaseFlowBookingCreationLoadingSelector = createLoadingSelector(
  createPurchaseFlowTripOfferBooking,
  createPurchaseFlowNonTripOfferBooking,
  getPurchaseFlowBookingById,
  // Change-booking commit: keep the offer-list "Continue" button pending
  // through `startExchange` + the manage-booking refetch so a double-click
  // can't create two PREBOOKED exchange operations.
  startExchange,
  getManageFlowBookingById
);

export const addAncillaryLoadingSelector = createLoadingSelector(
  addPurchaseFlowBookingAncillaries
);

export const checkoutLoadingSelector = createLoadingSelector(
  getPurchaseFlowBookingById,
  getPurchaseFlowBookingAdditionalOffersSearch,
  getPurchaseFlowTravelAccountsMap
);

export const manageBookingSearchLoadingSelector = createLoadingSelector(
  getManageFlowBookingByNumberAndEmail,
  getManageFlowTravelAccountsMap
);

export const manageBookingRefundLoadingSelector = createLoadingSelector(
  initiateLegsRefund,
  initiateExtrasRefund,
  initiateNonTripOffersRefund,
  deleteRefundOffer,
  confirmRefundOffer,
  getManageFlowBookingById
);

export const sendTicketsToEmailLoadingSelector =
  createLoadingSelector(sendTicketsToEmail);

export const sendPasswordResetLinkLoadingSelector = createLoadingSelector(
  sendPasswordResetLink
);

export const resetPasswordLoadingSelector =
  createLoadingSelector(resetPassword);

export const changePasswordLoadingSelector =
  createLoadingSelector(changePassword);

export const initiatePaymentLoadingSelector = createLoadingSelector(
  updateBookingPassengers,
  updatePurchaseFlowBookingPurchaser,
  initiateAdyenPayment,
  initiateKlixPayment,
  initiateExternalPayment,
  initiateZeroPayment
);

export const profileBookingSearchLoadingSelector = createLoadingSelector(
  getManageFlowBookingByNumberAndEmail,
  getManageFlowTravelAccountsMap,
  getProfileActiveTickets,
  getProfileHistoryTickets,
  getProfileActiveTravelPasses,
  getProfileHistoryTravelPasses,
  getProfileActiveVouchers,
  getProfileHistoryVouchers
);

export const updateProfileLoadingSelector =
  createLoadingSelector(updateProfile);

export const applyProfileCardLoadingSelector =
  createLoadingSelector(applyProfileCard);

export const deleteProfileLoadingSelector =
  createLoadingSelector(deleteProfile);

export const profileConsentsLoadingSelector =
  createLoadingSelector(getProfileConsents);

export const saveProfileConsentsLoadingSelector =
  createLoadingSelector(saveProfileConsents);

export const updatePassengersLoadingSelector = createLoadingSelector(
  updateBookingPassengers
);

export const cancelBookingLoadingSelector = createLoadingSelector(
  deletePurchaseFlowBooking
);

export const abandonExchangeLoadingSelector =
  createLoadingSelector(abandonExchange);
